import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { SellerStepOnePjComponent } from './seller-step-one-pj/seller-step-one-pj.component';
import { SellerStepTwoPjComponent } from './seller-step-two-pj/seller-step-two-pj.component';
import { SellerStepThreePjComponent } from './seller-step-three-pj/seller-step-three-pj.component';
import { SellerResumePjComponent } from './seller-resume-pj/seller-resume-pj.component';
import { SellerShellPjComponent } from './seller-shell-pj/seller-shell-pj.component';
import { SellerRepresentPjComponent } from './seller-represent-pj/seller-represent-pj/seller-represent-pj.component';
import { SellerProcuratorPjComponent } from './seller-procurator/seller-procurator-pj/seller-procurator-pj.component';
import { SellerDataPayPjComponent } from './seller-data-pay-pj/seller-data-pay-pj/seller-data-pay-pj.component';

const baseModules = [CommonModule, FormsModule, ReactiveFormsModule, SharedModule];

@NgModule({
  declarations: [
    SellerStepOnePjComponent,
    SellerStepTwoPjComponent,
    SellerStepThreePjComponent,
    SellerResumePjComponent,
    SellerShellPjComponent,
    SellerRepresentPjComponent,
    SellerProcuratorPjComponent,
    SellerDataPayPjComponent,
  ],
  imports: [baseModules],
})
export class SellerPjModule {}
